import {Component, OnInit} from '@angular/core';
import {ModalExtended} from 'ngx-dynamic-modal';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {FileUploadService} from '../../../../tools/elements/services/file-upload.service';
import {ServiceProviderPriceService} from '../../services/service-provider-price.service';
import {Ng2FileInputService} from 'ng2-file-input';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {AuxiliarService} from '../../../../../shared/services/auxiliar.service';

import Swal from "sweetalert2";

@Component({
  selector: 'app-service-provider-price-modal',
  templateUrl: './service-provider-price-modal.component.html',
  styleUrls: ['./service-provider-price-modal.component.scss']
})
export class ServiceProviderPriceModalComponent extends ModalExtended implements OnInit {

    data:any;
    formSearch:FormGroup;
    params:any;
    fileToUpload: File =null;
    fileUploadSub:any;
    enabled:boolean;
    errors:Object={};
    serverResponse:Object={};
    enclosures:any;
    delimiters:any;

    constructor(private uploader:FileUploadService,
                private servicePriceHandler: ServiceProviderPriceService,
                private ng2Inputservice:Ng2FileInputService,
                private alerta:AlertaService,
                private aux:AuxiliarService) {
        super();
        this.formSearch=new FormGroup(
            {
                'service_provider_pk':new FormControl(null,Validators.required),
                'currency_pk':new FormControl(null,Validators.required),
                'enclosure':new FormControl('DOUBLE_QUOTE'),
                'delimiter':new FormControl(';'),
                'perMinute':new FormControl('1'),
                'remove_existing_rows' : new FormControl('0', Validators.required)
            }
        )
    }

    ngOnInit() {
        this.params=this.data.params;
        this.enclosures=this.aux.getEnclosures();
            this.delimiters=this.aux.getDelimiters();
    }

    saveData(form){
        this.errors={};
        if (form.valid && this.fileToUpload != null){
            this.enabled=true;
            let submittedData = Object.assign({},form.value,this.params);
            let formData= this.uploader.fileUpload(this.fileToUpload,submittedData);
            this.fileUploadSub = this.servicePriceHandler.postServiceProviderPrice(formData)
                .subscribe(result=>{
                    if(result.hasOwnProperty('error')){
                        Swal({type: 'warning', title: 'Action not performed', text: result.error});
                        return;
                    }
                    if(result.hasOwnProperty('errors')){
                        this.errors = result['errors'];
                        return;
                    }
                    this.serverResponse=result;
                    }, error=>{
                    this.enabled=false;
                }, () => {
                    this.enabled=false;
                    this.ng2Inputservice.reset('file');
                    this.fileToUpload=null;
                    form.markAsPristine();
                });
            }


    }

    selectFile(event){
        this.fileToUpload = event.file;
    }

    confirmUpload(confirm){
        if(!confirm){
            this.serverResponse={};
            this.alerta.addAlert('warning','Cancelled!!')
            this.close();
            return false;
        }
        this.enabled=true;
        this.servicePriceHandler.postServiceProviderPrice({path:this.serverResponse['path'],params:this.serverResponse['params']})
            .subscribe( result => {
                this.serverResponse={};
                this.alerta.addAlert('success',result['status'])
            }, error => {
                this.enabled=false;
                this.alerta.addAlert('error','Something went Wrong!!')
            }, () => {

                this.enabled=false;
                this.close();
            })
    }

}


// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/modals/service-provider-price-modal/service-provider-price-modal.component.ts